import { Component } from '@angular/core';

import { Platform, ModalController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LocalStorageKeys } from '../constants/LocalStorageKeys';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent {

    routeUrlHistory: any[] = [];
    routeHistory: any[] = [];
    prevRoute: any;

    static skipModalCheck: boolean = false;

    //Set to true when logged out. And to false when logged in.
    static completelyStopModalCheck: boolean = false;

    static readonly modalsKey:string = 'component_modals';
    
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private modalController: ModalController,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.initializeApp();

        var queryParamsEvent = this.activatedRoute.queryParams.subscribe(async params => {
            if (params[AppComponent.modalsKey]) {

                var newParams = {};
                newParams[AppComponent.modalsKey] = null;

                await this.router.navigate(
                    [],
                    {
                        relativeTo: this.activatedRoute,
                        queryParams: newParams,
                        queryParamsHandling: 'merge', // remove to replace all query params by provided
                    });

                //this.handleModals();
            }
            else {
                this.backButtonHandler();
            }

            if (queryParamsEvent !== undefined) {
                queryParamsEvent.unsubscribe();
            }
        });

        

        //this.router.events.subscribe((val) => {
        //    if (val instanceof NavigationEnd) {

        //        //1, 2, 3

        //        if (this.routeUrlHistory[this.routeUrlHistory.length - 2] === val.urlAfterRedirects) {

        //            var stayAt = this.routeUrlHistory[this.routeUrlHistory.length - 1];

        //            //this.routeUrlHistory.pop();
        //            //this.routeHistory.pop();

        //            this.router.navigateByUrl(stayAt);
        //            return;
        //        }
        //        else {

        //            if (this.routeUrlHistory[this.routeUrlHistory.length - 1] === val.urlAfterRedirects) {
        //                //Prevented
        //            }
        //            else {
        //                this.routeHistory.push(val);
        //                this.routeUrlHistory.push(val.urlAfterRedirects);
        //            }
        //        }

        //        //alert(this.routeUrlHistory)
        //    }
        //});
    }

    backButtonHandler() {
        this.router.events.subscribe((val) => {
            if (!AppComponent.completelyStopModalCheck && val instanceof NavigationEnd) {
                if ((!AppComponent.skipModalCheck && this.prevRoute && this.prevRoute.indexOf(AppComponent.modalsKey) > -1) || (!AppComponent.skipModalCheck && val.urlAfterRedirects.indexOf(AppComponent.modalsKey) > -1))
                    this.router.navigateByUrl(this.prevRoute);
                else
                    this.prevRoute = val.urlAfterRedirects;

                AppComponent.skipModalCheck = false;
            }
        });
    }

    public static setumModalBackButtonHandler(modal, activatedRoute: ActivatedRoute, router: Router) {
        AppComponent.pushModal(activatedRoute, router);

        modal.onDidDismiss().then(x => {
            AppComponent.popModal(activatedRoute, router);
        });
    }

    public static pushModal(activatedRoute: ActivatedRoute, router: Router) {
        AppComponent.pushPopModal(activatedRoute, router, false);
    }

    public static popModal(activatedRoute: ActivatedRoute, router: Router) {
        AppComponent.pushPopModal(activatedRoute, router, true);
    }

    public static pushPopModal(activatedRoute: ActivatedRoute, router: Router, popMode: boolean) {

        var queryParamsEvent = activatedRoute.queryParams.subscribe(params => {

            if (queryParamsEvent) {
                queryParamsEvent.unsubscribe();
                return;
            }

            var modals = params[AppComponent.modalsKey];

            if (!modals)
                modals = 1;
            else
                modals = Number(modals) + (popMode ? -1 : 1);

            var newParams = {};
            newParams[AppComponent.modalsKey] = modals === 0 ? null : modals;

            //alert(modals)
            AppComponent.skipModalCheck = true;

            router.navigate(
                [],
                {
                    relativeTo: activatedRoute,
                    queryParams: newParams,
                    queryParamsHandling: 'merge', // remove to replace all query params by provided
                });
        });
    }



    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }
}
